import { render } from "./userAttributesField.vue?vue&type=template&id=bf31d438&ts=true"
import script from "./userAttributesField.vue?vue&type=script&lang=ts"
export * from "./userAttributesField.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__